import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {UserService} from '@iw-shop/user/services/user.service';
import {AppState} from '@store/state/app.state';
import {Store} from '@ngrx/store';
import {resetTokensExpire} from '@store/actions/storage.action';
import {AuthenticationService} from '@iw-shop/core/services/authentication.service';
import {FormStatus} from '@iw-shop/forms/components/submit-button/submit-button.component';

@Component({
    selector: 'iw-shop-user-password-reset',
    standalone: false,
    templateUrl: './user-password-reset.component.html',
    styleUrls: ['./user-password-reset.component.scss']
})
export class UserPasswordReset implements OnInit {
    @Input() buttonClass: string = 'is-primary';

    isToken: boolean = false;

    formStatus: FormStatus = null;

    form: FormGroup;
    error: string = '';

    constructor(private fb: FormBuilder, private store: Store<AppState>, private userService: UserService, private authenticationService: AuthenticationService, private router: Router) {
        this.form = this.fb.group({
            password: this.fb.control('', [Validators.required]),
            passwordRetype: this.fb.control('', [Validators.required]),
            userId: this.fb.control('', [Validators.required])
        });
    }

    ngOnInit(): void {
        if (this.authenticationService.isInjectionToken() &&
            !this.authenticationService.isAccessTokenExpired(1)) {
            this.isToken = true;
            this.form.get('userId')?.setValue(this.authenticationService.getPayloadFromInjectionToken().userId);
        }
    }

    isFormValid(): boolean {
        if (!this.form.valid) {
            if (!this.form.get('userId')?.valid) {
                this.error = 'Die userId konnte nicht ermittelt werden. Bitte kontaktieren Sie uns.';
            } else {
                this.error = 'Bitte hinterlegen Sie ein Passwort';
            }
            return false;
        }

        if (this.form.get('password')?.value != this.form.get('passwordRetype')?.value) {
            this.error = 'Die hinterlegten Passwörter stimmen nicht überein';
            return false;
        }


        this.error = '';
        return true;
    }

    submit() {
        if (this.isFormValid()) {
            this.formStatus = 'loading';
            this.userService.updatePassword(this.form.get('userId')?.value, this.form.get('password')?.value)
                .pipe(
                )
                .subscribe(
                    {
                        next: r => {
                            if (r.error?.message) {
                                this.error = r.error?.message;
                                this.formStatus = 'submitForm';
                            } else if (r.result?.users.updated) {
                                this.form.reset();
                                this.store.dispatch(resetTokensExpire());
                                this.formStatus = 'success';
                            } else {
                                this.formStatus = 'submitForm';
                                this.error = 'Es ist ein unbekannter Fehler aufgetreten.'
                            }
                        },
                        error: () => {
                            this.formStatus = 'submitForm';
                        },
                        complete: () => {
                        }
                    }
                )
        }
    }
}
